/**
 * 路由配置
 *
 * 采用单路由 + 动态组件模式：
 * - 所有路径统一匹配到 AppRoot 组件
 * - AppRoot 根据登录态渲染 Login 或 Layout
 * - Layout 内部通过 componentRegistry 动态加载页面组件
 * - URL 仅用于初始访问，菜单点击不改变 URL
 */
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // 根路由：AppRoot 根据登录态渲染 Login 或 Layout
  {
    path: '/',
    component: () => import('@/views/a0/AppRoot.vue'),
  },
  // 通配路由：所有其他路径也交给 AppRoot 处理（支持直接 URL 访问）
  {
    path: '/:pagePath(.*)*',
    component: () => import('@/views/a0/AppRoot.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
